(function() {
    'use strict';

    function initTaxonomyDescription() {
        const descriptions = document.querySelectorAll('.taxonomy-description');
        
        descriptions.forEach(desc => {
            const content = desc.querySelector('.taxonomy-description-content');
            if (!content) return;

            // Используем requestAnimationFrame, чтобы убедиться, что стили применены
            requestAnimationFrame(() => {
                if (content.scrollHeight > content.offsetHeight + 1) {
                    desc.classList.add('has-toggle');
                    
                    const btn = document.createElement('button');
                    btn.className = 'read-more-toggle';
                    btn.type = 'button';
                    btn.textContent = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.readMore) || 'Read more';
                    
                    desc.appendChild(btn);
                    
                    btn.addEventListener('click', function() {
                        const isExpanded = content.classList.contains('is-expanded');
                        
                        if (!isExpanded) {
                            content.classList.add('is-expanded');
                            btn.textContent = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.close) || 'Close';
                            content.style.maxHeight = content.scrollHeight + 'px';
                        } else {
                            content.classList.remove('is-expanded');
                            btn.textContent = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.readMore) || 'Read more';
                            content.style.maxHeight = '';
                        }
                    });
                }
            });
        });
    }

    // Инициализация при загрузке страницы
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTaxonomyDescription);
    } else {
        initTaxonomyDescription();
    }

    // Слушаем событие content-loaded (может быть полезно для AJAX-подгрузки, хотя описание обычно грузится сразу)
    document.body.addEventListener('content-loaded', function() {
        initTaxonomyDescription();
    });

})();
